import React, { useState } from "react";
import styles from "./A23GameTypeHeader.module.css";
import { useNavigate } from "react-router";
import gameAssets from "@themed-assets";
import { HEADER_GAME_TYPES } from "@/Poker/data/Constants";
import usePlatformCommunication from "@/src/hooks/utils/usePlatformCommunication";
import usePlayerBalance from "@/src/hooks/data/usePlayerBalance";
import { FaChevronLeft, FaArrowLeft, FaChevronDown, FaLock } from "react-icons/fa";
import GameTypeDrawer from "@/src/components/GameTypeDrawer/GameTypeDrawer";
import { FaStarOfLife } from "react-icons/fa";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { MdOutlineStar } from "react-icons/md";
import { IoMdStarOutline } from "react-icons/io";
import useAddGameToFavorite from "@/src/hooks/utils/useAddGameToFavorite";
import usePlayerDetails from "@/src/hooks/data/usePlayerDetails";

export default function A23GameTypeHeader({
  headerName,
  type,
  showGameTypes = true,
  onGameTypeChange,
  roomId,
  isFavorite,
}) {
  const playerBalance = usePlayerBalance();
  const { pseudo } = usePlayerDetails();
  const navigate = useNavigate();
  const { addCashNavigation, walletNavigation } = usePlatformCommunication();
  const [currentType, setCurrentType] = useState(type);
  const [hidePlayerBalance, setHidePlayerBalance] = useState(false);
  const { handleSaveFavoriteRequest } = useAddGameToFavorite({ isGame: false });

  const goBack = () => {
    if (type === HEADER_GAME_TYPES.TABLE) {
      return navigate("/cashLobby");
    } else {
      return navigate("/");
    }
  };

  const handleGameTypeChange = (newType) => {
    setCurrentType(newType);
    if (onGameTypeChange) {
      onGameTypeChange(newType);
    }
  };

  return (
    <header className={styles.container}>
      <div className={styles.leftSection}>
        <button onClick={goBack} className={styles.backButton}>
          <FaArrowLeft color="var(--color-h-primary)" size={16} />
        </button>
        {showGameTypes ? (
          <GameTypeDrawer
            type={currentType}
            onGameTypeChange={handleGameTypeChange}
            className={styles.gameTypeDrawer}
          >
            <div className={styles.gameType + " flex"}>
              <img
                src={
                  currentType === HEADER_GAME_TYPES.CASH
                    ? gameAssets.cashIcon
                    : gameAssets.tourneyCup
                }
                className={styles.gameTypeIcon}
                alt={
                  currentType === HEADER_GAME_TYPES.CASH
                    ? "Cash game"
                    : "Tournament"
                }
              />
              <span>{currentType}</span>
              {/* Down Chevron */}
              <FaChevronDown color="var(--color-h-primary)" size={10} />
            </div>
          </GameTypeDrawer>
        ) : null}
        {type === HEADER_GAME_TYPES.TABLE && (
          <div className={styles.tableType}>
            <span>{headerName}</span>
          </div>
        )}
      </div>
      <div className={styles.rightSection}>
        <div className={styles.balance}>
          {
            pseudo ?
              <FaLock color="var(--color-error-primary)" size={16} />
              :
              !hidePlayerBalance ? (
                <IoEye
                  onClick={() => setHidePlayerBalance(!hidePlayerBalance)}
                  color="var(--color-h-primary)"
                  size={16}
                />
              ) : (
                <IoEyeOff
                  onClick={() => setHidePlayerBalance(!hidePlayerBalance)}
                  color="var(--color-h-primary)"
                  size={16}
                />
              )}
          <span
            id="wallet-balance-span-gameType-header"
            onClick={() => {
              if (hidePlayerBalance) {
                setHidePlayerBalance(false);
              } else {
                walletNavigation();
              }
            }}
            className={styles.balanceAmount}
            style={pseudo ? { color: "var(--color-error-primary)" } : !hidePlayerBalance ? { color: "var(--color-primary)" } : {}}
          >
            {hidePlayerBalance ? (
              <div className={styles.starContainer}>
                {Array.from({
                  length: Math.max(playerBalance.totalBalance.length - 2, 3),
                }).map((_, index) => (
                  <FaStarOfLife
                    key={index}
                    color="var(--color-h-secondary)"
                    size={9}
                  />
                ))}
              </div>
            ) : (
              `₹${playerBalance.totalBalance}`
            )}
          </span>
        </div>
        <button
          id="add-cash-button-gameType-header"
          onClick={addCashNavigation}
          className={styles.addButton}
          aria-label="Add funds"
        >
          +
        </button>
        {type === HEADER_GAME_TYPES.TABLE && (
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              handleSaveFavoriteRequest(roomId);
            }}
          >
            {isFavorite ? (
              <MdOutlineStar size={24} color={"var(--color-accent-theme)"} />
            ) : (
              <IoMdStarOutline size={24} color={"var(--color-secondary)"} />
            )}
          </div>
        )}
      </div>
    </header>
  );
}
